import { cn } from '../lib/cn.js'

/**
 * Guia: "O logo aparece sempre sobre o laranja Dú. Em outros fundos, use uma
 * placa laranja atrás dele." Área de proteção = altura da letra D.
 * Tamanho mínimo digital: 120 px.
 *
 * Por isso o componente SEMPRE desenha a placa laranja: não existe caminho
 * para aplicar o logo solto num fundo qualquer.
 */
export type LogoMarkProps = {
  /** Largura da placa em px. O guia proíbe menos de 120. */
  largura?: number | undefined
  src?: string | undefined
  comPlaca?: boolean | undefined
  className?: string | undefined
}

/**
 * A arte da marca, servida pelos dois apps em /logo-du-320.webp.
 *
 * O desenho é colorido (vermelho, amarelo, creme) e tem identidade própria —
 * sobre a placa laranja ele embaralha. Por isso, quando é a ARTE que aparece,
 * a placa sai; a regra do guia de "sempre sobre o laranja" foi escrita para o
 * logotipo em texto, que é monocromático e some em fundo claro.
 *
 * O texto continua existindo como alternativa: é ele que aparece se a imagem
 * não carregar, e em qualquer lugar que passe comPlaca.
 */
const ARTE_PADRAO = '/logo-du-320.webp'

const MINIMO_DIGITAL = 120

export function LogoMark({ largura = 160, src, comPlaca, className }: LogoMarkProps) {
  const arte = src ?? ARTE_PADRAO
  // A placa só entra quando pedida de propósito, ou quando não há arte.
  const placa = comPlaca ?? false
  const l = Math.max(largura, MINIMO_DIGITAL)
  // Área de proteção: altura da letra "D" ≈ 0,22 da largura da marca.
  const respiro = Math.round(l * 0.11)

  const conteudo = !placa ? (
    <img
      src={arte}
      alt="Dú Lanches"
      // A arte tem 677x368: a proporção vai explícita para o navegador não
      // pular o layout quando a imagem chega (CLS).
      width={677}
      height={368}
      style={{ width: '100%', height: 'auto', display: 'block' }}
    />
  ) : (
    <span className="du-logo__texto">
      DÚ<span className="du-logo__ponto">·</span>LANCHES
    </span>
  )

  if (!placa) return <span className={cn('du-logo', className)} style={{ width: l }}>{conteudo}</span>

  return (
    <span
      className={cn('du-logo du-logo--placa', className)}
      style={{ width: l, padding: respiro }}
    >
      {conteudo}
    </span>
  )
}
